import apiClient from '../config/api';

const kaizenService = {
  /**
   * Get all Kaizen ideas
   * @param {number} statusId - Optional status ID filter
   * @param {number} submitterId - Optional submitter ID filter
   * @returns {Promise} Array of Kaizen ideas
   */
  getAllKaizenIdeas: async (statusId = null, submitterId = null) => {
    const params = {};
    if (statusId) params.statusId = statusId;
    if (submitterId) params.submitterId = submitterId;
    
    const response = await apiClient.get('/kaizenidea', { params });
    return response.data;
  },

  /**
   * Get Kaizen idea by ID
   * @param {number} ideaId - Kaizen idea ID
   * @returns {Promise} Kaizen idea details with actions
   */
  getKaizenIdeaById: async (ideaId) => {
    const response = await apiClient.get(`/kaizenidea/${ideaId}`);
    return response.data;
  },

  /**
   * Create Kaizen idea
   * @param {object} ideaData - Kaizen idea data
   * @returns {Promise} Created Kaizen idea
   */
  createKaizenIdea: async (ideaData) => {
    const response = await apiClient.post('/kaizenidea', ideaData);
    return response.data;
  },

  /**
   * Update Kaizen idea
   * @param {number} ideaId - Kaizen idea ID
   * @param {object} ideaData - Updated Kaizen idea data
   * @returns {Promise} Updated Kaizen idea
   */
  updateKaizenIdea: async (ideaId, ideaData) => {
    const response = await apiClient.post(`/kaizenidea/update/${ideaId}`, ideaData);
    return response.data;
  },

  /**
   * Approve Kaizen idea
   * @param {number} ideaId - Kaizen idea ID
   * @returns {Promise} Approved Kaizen idea
   */
  approveKaizenIdea: async (ideaId) => {
    const response = await apiClient.post(`/kaizenidea/${ideaId}/approve`);
    return response.data;
  },

  /**
   * Delete Kaizen idea
   * @param {number} ideaId - Kaizen idea ID
   * @returns {Promise} Deletion result
   */
  deleteKaizenIdea: async (ideaId) => {
    const response = await apiClient.post(`/kaizenidea/delete/${ideaId}`);
    return response.data;
  },
};

export default kaizenService;





































































